// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"927":"Employees","966":"dashboard"}[chunkId] || chunkId) + "." + {"62":"9768275d","376":"677a822a","927":"cb07c23d","966":"23419573"}[chunkId] + ".css";
};